<template>
    <div class="mb-6">
        <div
            class="header pb-5 pt-4"
            :style="backgroundStyle"
            :class="layout && publicUser ? 'nch-navbar--fixed' : ''"
        >
            <div
                v-if="plan.layout.dashboard_img && !plan.layout.dashboard_img_option"
                class="col-12 text-center mb-4"
            >
                <img
                    class="rounded img-fluid img-center"
                    :src="image(plan.layout.dashboard_img)"
                    alt="Imagem do Plano"
                />
            </div>
            <div class="container pt-4">
                <div class="card">
                    <div class="plan__header">
                        <h2
                            class="text-center"
                            :class="plan.total_expiration_days ? 'mb-1' : 'mb-0'"
                        >{{ plan.translation.name }}</h2>
                        <div v-if="plan.total_expiration_days">
                            <div class="d-flex justify-content-center">
                                <h4
                                    class="mb-0 mr-1"
                                    :class="statusColorExpiration"
                                >{{ $t('dashboard.expiration_days') }}:</h4>
                                <h4
                                    class="mb-0"
                                    :class="statusColorExpiration"
                                >{{ expirationDays }}</h4>
                            </div>
                            <div class="d-flex justify-content-center">
                                <h4
                                    class="mb-0 mr-1"
                                    :class="statusColorExpiration"
                                >{{ $t('dashboard.expiration_date') }}:</h4>
                                <h4
                                    class="mb-0"
                                    :class="statusColorExpiration"
                                >{{ $moment(plan.expiration_date).format('DD/MM/YYYY') }}</h4>
                            </div>
                        </div>

                    </div>
                    <div class="plan__description ql-editor" :class="expand ? 'expand' : ''" id="description">
                        <span v-html="plan.translation.description"></span>
                    </div>
                    <span
                        @click="expand = !expand"
                        v-if="showExpand"
                        class="plan__footer text-center"
                    >{{expand ? $t('common.see_less') : $t('common.expand')}}</span>

                    <div class="text-center p-1" v-if="showCertificate">
                        <certificate-link
                            :certificate="certificate"
                            :relation="{type: 'plan', id: plan.id}"
                        ></certificate-link>
                    </div>
                </div>

                <!-- <ProgressBar v-if="publicUser" :plan-id="plan.id" /> -->
            </div>
        </div>
        <div
            v-if="!released"
            class="content"
            style="min-height: 68vh"
        >
            <div class="container mt--5">
                <div>
                    <!-- <h3 class="card-title">{{$t('dashboard.content')}}</h3> -->
                    <div class="grid">
                        <DashboardContentCard
                            v-for="(content, i) in contents"
                            :key="i"
                            :type="content.type"
                            :color="color"
                            :content="content"
                            :plan-id="plan.id"
                            :public-lesson-urls="publicLessonUrls"
                            :public-course-urls="publicCourseUrls"
                        />
                    </div>
                    <loading-spinner v-if="loading" :color="color"></loading-spinner>
                </div>
            </div>
        </div>
        <Modal
            :show="released"
        >
            <i class="ni ni-time-alarm ni-2x"></i>
            <h1
                class="display-2 text-center bg-primary text-secondary rounded border-primary"
            >
                {{ $t('dashboard.plan.unavailable_content') }}
            </h1>
            <h3 class="text-center">
                {{ $t('dashboard.plan.release_date') }}
                <b>{{ $moment(released).format('DD/MM/YYYY') }}</b>
            </h3>
            <button class="btn btn-primary float-right" @click="back">Voltar</button>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios';
import PlanSelectModal from './DashboardComponents/DashboardPlanSelectModal';
import Empty from './Common/Empty';
import LoadingSpinner from './Common/LoadingSpinner';
import ProgressBar from './Common/ProgressBar';
import DashboardContentCard from './DashboardComponents/DashboardContentCard';
import CertificateLink from '../components/Certificate/CertificateLink';

import BaseButton from '../argon/components/BaseButton';
import Card from '../argon/components/Cards/Card';
import Collapse from '../argon/components/Collapse/Collapse';
import CollapseItem from '../argon/components/Collapse/CollapseItem';
import Modal from '../argon/components/Modal';

import image from '../mixins/image';

export default {
    name: 'Dashboard',
    mixins: [image],
    props: {
        color: {
            type: Object,
            required: true,
        },
        plan: {
            type: Object,
            required: true,
        },
        breadcrumb: String,
        publicUser: [Boolean, Number],
        token: String,
        contentsApiUrl: {
            type: String,
            default: '',
        },
        publicLessonUrls: {
            type: Object,
            default: () => ({}),
        },
        publicCourseUrls: {
            type: Object,
            default: () => ({}),
        },
        certificate: Object,
    },
    components: {
        PlanSelectModal,
        Empty,
        LoadingSpinner,
        ProgressBar,
        BaseButton,
        Card,
        Collapse,
        CollapseItem,
        Modal,
        DashboardContentCard,
        CertificateLink,
    },
    data() {
        return {
            modal: false,
            contents: [],
            links: {},
            meta: {},
            loading: false,
            descriptionSize: null,
            expand: false,
            released: this.plan.release_date,
        };
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.contents.push(...value.data);
                this.links = value.links;
                this.meta = value.meta;
            },
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        layout() {
            return this.$store.getters.NAVBAR_FIXED;
        },
        backgroundStyle() {
            if (
                this.plan.layout.dashboard_img &&
                this.plan.layout.dashboard_img_option
            ) {
                return {
                    background: `url(${this.image(
                        this.plan.layout.dashboard_img,
                    )}) center center/cover no-repeat`,
                    paddingTop: '150px',
                };
            }
            return this.$bgColor(this.color.primary);
        },
        showExpand() {
            if (this.descriptionSize > 250) {
                return true;
            }
            return false;
        },
        calcPercentageExpiration() {
            if (this.plan.current_expiration_days !== -1) {
                return (this.plan.current_expiration_days * 100) / this.plan.total_expiration_days;
            }
            return 0;
        },
        statusColorExpiration() {
            if (this.calcPercentageExpiration < 34) {
                return 'text-danger';
            }
            return 'text-black-50';
        },
        expirationDays() {
            if (this.plan.current_expiration_days > 1) {
                return this.plan.current_expiration_days;
            } else if (this.plan.current_expiration_days === 1) {
                return this.$t('dashboard.tomorrow');
            } else if (this.plan.current_expiration_days === 0) {
                return this.$t('dashboard.today');
            }
            return this.$t('dashboard.expired');
        },
        progress() {
            return this.$store.getters.LOADED_PROGRESS;
        },
        showCertificate() {
            let certificateProgress = null;

            if (this.certificate && this.certificate.progress) {
                certificateProgress = parseInt(this.certificate.progress, 10);
            }

            if (certificateProgress && this.progress && this.progress >= certificateProgress) {
                return true;
            }

            return false;
        },
    },
    methods: {
        loadPlan(page = false) {
            if (!this.loading) {
                this.$loading.show();
            }

            let request;

            if (this.publicUser) {
                // Cenário Público: Usa a URL assinada, construindo a URL final manualmente
                // para não invalidar a assinatura com o parâmetro 'page'.
                const finalUrl = `${this.contentsApiUrl}`;
                request = axios.get(finalUrl);
            } else {
                // Cenário de Usuário Normal: Usa a URL padrão com o token de autorização.
                const apiUrl = `/api/app/plan/${this.plan.id}/contents`;
                const headers = {
                    ...axios.defaults.headers.common,
                    Authorization: `Bearer ${this.token}`,
                };
                request = axios.get(apiUrl, { headers, params: { page: page || 1 } });
            }

            return request
                .then((res) => {
                    if (typeof res.data.data === 'string') {
                        window.location.href = res.data.data;
                    } else {
                        this.data = res.data;
                        this.modal = false;
                    }
                })
                .catch(err => console.error(err))
                .finally(() => this.$loading.close());
        },
        goBack() {
            this.$loading.show();
            window.location.href = '/plans';
        },
        scroll() {
            window.onscroll = async () => {
                const bottomOfWindow =
                    Math.round(document.documentElement.scrollTop + window.innerHeight) >=
                    (document.documentElement.offsetHeight - 50);

                if (
                    bottomOfWindow &&
                    this.contents.length !== this.meta.total &&
                    !this.loading
                ) {
                    this.loading = true;
                    await this.loadPlan(this.meta.current_page + 1);
                    this.loading = false;
                }
            };
        },
        back() {
            window.history.back();
        },
    },
    beforeMount() {
        if (this.token) {
            localStorage.setItem('nochalks_token', this.token);
        }
    },
    async mounted() {
        await this.loadPlan();
        this.scroll();
        this.descriptionSize = document.getElementById(
            'description',
        ).scrollHeight;
    },
};
</script>

<style scoped>
.plan__description {
    max-height: 250px;
    overflow: auto;
    padding: 20px;
    transition: max-height 0.3s linear;
}
.expand {
    max-height: 55vh;
}
.plan__header {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
}

.plan__footer {
    padding: 10px 0;
    border-top: 1px solid #eee;
    cursor: pointer;
}

.shadow-small {
    box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
}

.nch--collapse {
    border-radius: 5px !important;
}
.grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 30px;
    max-width: 1100px;
    margin: 0 auto 30px;
    padding: 5px 20px;
}
</style>
